
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class SysGroupDialog extends Serenity.EntityDialog<SysGroupRow, any> {
        protected getFormKey() { return SysGroupForm.formKey; }
        protected getIdProperty() { return SysGroupRow.idProperty; }
        protected getLocalTextPrefix() { return SysGroupRow.localTextPrefix; }
        protected getNameProperty() { return SysGroupRow.nameProperty; }
        protected getService() { return SysGroupService.baseUrl; }
        protected getDeletePermission() { return SysGroupRow.deletePermission; }
        protected getInsertPermission() { return SysGroupRow.insertPermission; }
        protected getUpdatePermission() { return SysGroupRow.updatePermission; }

        protected form = new SysGroupForm(this.idPrefix);

    }
}